module.exports = __webpack_public_path__ + "img/main-logo-min.27fa1042.svg";